import { render, staticRenderFns } from "./FormAccordionV2.vue?vue&type=template&id=e6f1cb68&"
import script from "./FormAccordionV2.vue?vue&type=script&lang=js&"
export * from "./FormAccordionV2.vue?vue&type=script&lang=js&"
import style0 from "./FormAccordionV2.vue?vue&type=style&index=0&id=e6f1cb68&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f1cb68')) {
      api.createRecord('e6f1cb68', component.options)
    } else {
      api.reload('e6f1cb68', component.options)
    }
    module.hot.accept("./FormAccordionV2.vue?vue&type=template&id=e6f1cb68&", function () {
      api.rerender('e6f1cb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FormAccordionV2.vue"
export default component.exports